import { useStep } from 'components/flow/step/step.hooks';
import SpreedlyCVVDialogContext from 'components/payment/spreedly/spreedly-card/spreedly-cvv-dialog/spreedly-cvv-dialog.context';
import { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

export const useGiftCardPaymentStep = ({
  purchaseLoading,
  isLoading,
  trigger,
  paymentToken,
}) => {
  const history = useHistory();
  const { handleCheckWithCVVRecacheDialogAndDoPayment } = useContext(
    SpreedlyCVVDialogContext,
  );

  const {
    data: { giftcardData },
  } = useStep();

  const loading = useMemo(
    () => isLoading || purchaseLoading,
    [isLoading, purchaseLoading],
  );

  const processOrder = async spreedlyToken => {
    try {
      const handleProcessOrder = async () => {
        const res = await trigger(paymentToken ?? spreedlyToken);
        if (!!res?.data)
          history.push('/giftcard/thankyou', { ...giftcardData, ...res.data });
      };
      await handleCheckWithCVVRecacheDialogAndDoPayment(handleProcessOrder);
    } catch (error) {
      toast.error(error?.cause?.message ?? error?.message);
    }
  };
  return { processOrder, loading };
};
